import type { ReadingCompanionProps } from "@op/puck-types";

const ReadingCompanion = (_props: ReadingCompanionProps) => {
  return null;
};

export default ReadingCompanion;
